import { Card } from '@/components/ui/card'
import { PageContent } from '@/components/shared/page-content'
import { HeaderSection } from '@/components/shared/header-section'
import { Icons } from '@/components/shared/icons'
import { Link } from 'react-router-dom'
import { SlidersHorizontal } from 'lucide-react'

export default function Settings() {
  return (
    <PageContent>
      <div className="flex justify-between items-center mb-8">
        <HeaderSection title="Settings" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6">
        <Link to="/settings/ui">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-blue-100 rounded-lg">
                <Icons.monitor className="w-8 h-8 text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">UI Settings</h3>
                <p className="text-gray-600">
                  Configure user interface features and display options.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/translations">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-emerald-100 rounded-lg">
                <Icons.email className="w-8 h-8 text-emerald-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">
                  Emails and Templates
                </h3>
                <p className="text-gray-600">
                  Configure email templates and settings for your application.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/login-attempts">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-blue-100 rounded-lg">
                <Icons.shield className="w-8 h-8 text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Login Attempts</h3>
                <p className="text-gray-600">
                  Monitor and review all login attempts and security events.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/languages">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-purple-100 rounded-lg">
                <Icons.globe className="w-8 h-8 text-purple-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">
                  Language Settings
                </h3>
                <p className="text-gray-600">
                  Configure which languages are available for your shop.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/admin">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-orange-100 rounded-lg">
                <Icons.settings className="w-8 h-8 text-orange-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Admin Settings</h3>
                <p className="text-gray-600">
                  Configure product translation actions and admin-level
                  settings.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/fabric">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-rose-100 rounded-lg">
                <Icons.palette className="w-8 h-8 text-rose-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Fabric Settings</h3>
                <p className="text-gray-600">
                  Configure stock messages and availability threshold for
                  fabrics.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/home-page">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-teal-100 rounded-lg">
                <Icons.home className="w-8 h-8 text-teal-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Home Page</h3>
                <p className="text-gray-600">
                  Manage content blocks displayed on the homepage.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/navigation">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-indigo-100 rounded-lg">
                <Icons.dashboard className="w-8 h-8 text-indigo-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Navigation</h3>
                <p className="text-gray-600">
                  Manage the B2B portal's navbar mega menu and links.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/footer">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-cyan-100 rounded-lg">
                <Icons.contact className="w-8 h-8 text-cyan-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Footer</h3>
                <p className="text-gray-600">
                  Manage the B2B portal's footer columns, links, and contact info.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/product">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-amber-100 rounded-lg">
                <Icons.tags className="w-8 h-8 text-amber-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Product</h3>
                <p className="text-gray-600">
                  Configure which product tags anonymous B2B portal visitors
                  can see.
                </p>
              </div>
            </div>
          </Card>
        </Link>

        <Link to="/settings/filters">
          <Card className="p-6 hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-2 bg-lime-100 rounded-lg">
                <SlidersHorizontal className="w-8 h-8 text-lime-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">Filters</h3>
                <p className="text-gray-600">
                  Configure which attribute groups appear as sections in the
                  B2B portal Filters panel, and in what order.
                </p>
              </div>
            </div>
          </Card>
        </Link>
      </div>
    </PageContent>
  )
}
